import { render, staticRenderFns } from "./CompraJoseAngelCruz.vue?vue&type=template&id=a38e3260&"
import script from "./CompraJoseAngelCruz.vue?vue&type=script&lang=js&"
export * from "./CompraJoseAngelCruz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports